import { render, staticRenderFns } from "./PixDetailsDialog.vue?vue&type=template&id=4e40e45a"
import script from "./PixDetailsDialog.vue?vue&type=script&lang=js"
export * from "./PixDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./PixDetailsDialog.vue?vue&type=style&index=0&id=4e40e45a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports